import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListTableService {
  public filterSubject$ = new BehaviorSubject<any>(null);

  public getFilter(): Observable<any> {
    return this.filterSubject$.asObservable();
  }

  public setFilter(filter: any): void {
    this.filterSubject$.next(filter);
  }

  public resetFilter(): void {
    this.filterSubject$.next(null);
  }
}
